import { render, staticRenderFns } from "./accountRegistrationInvite.vue?vue&type=template&id=0df070ea&"
import script from "./accountRegistrationInvite.vue?vue&type=script&lang=js&"
export * from "./accountRegistrationInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports